import React from 'react';
import './UserName.css'

const UserName = () => (
  <div className='userName' > 
    Diego Motta 
  </div>
 
);

export default UserName;